import { createContext, useState } from 'react'
import PropTypes from 'prop-types'

export const FilterContext = createContext()

const FilterProvider = (props) => {
  const { children } = props
  // states
  const [filter, setFilter] = useState('')
  const [selectedFilters, setSelectedFilters] = useState({ exercises: {}, trainings: {}, programs: {} })
  const [calendarTrainingSelection, setCalendarTrainingSelection] = useState({})
  const [calendarExerciseSelection, setCalendarExerciseSelection] = useState({})
  const [resetFilters, setResetFilters] = useState(false)
  const [from, setFrom] = useState(8)
  const [total, setTotal] = useState(0)

  return (
    <FilterContext.Provider
      value={{
        filter,
        setFilter,
        selectedFilters,
        setSelectedFilters,
        calendarTrainingSelection,
        setCalendarTrainingSelection,
        calendarExerciseSelection,
        setCalendarExerciseSelection,
        resetFilters,
        setResetFilters,
        total,
        setTotal,
        from,
        setFrom
      }}
    >
      {/* eslint-disable-next-line react/prop-types */}
      {children}
    </FilterContext.Provider>
  )
}

FilterProvider.propTypes = {
  children: PropTypes.object
}

export default FilterProvider
